<template>
  <custom-dialog class="location-item-dialog" :title="model.title" width="500px" :visible="visible" v-on="$listeners">
    <div class="title-box" v-if="model.type !== 'setBatch'">
      <p class="location">{{ model.data.locationName }} {{ model.data.siteName||'-' }}</p>
      <p class="goal"><span v-if="model.data.goalArea">{{ model.data.goalArea?`${$formatLenLocal(model.data.goalArea) }${$formatLenUnit()}`:'' }}</span> <span v-if="model.data.goalTime">{{ model.data.goalTime?`${model.data.goalTime}min`:'' }}</span> </p>
    </div>
    <div class="dialog-body">
      <el-form ref="form" :model="form" :rules="rules" :validate-on-rule-change="false">
        <el-row>
          <el-col>
            <el-form-item :label="cleanAreaDay" prop="goalArea">
              <el-input v-model="form.goalArea"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item :label="$t('location_set_dialog.qjscmint')" prop="goalTime">
              <el-input v-model="form.goalTime"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button plain @click="closeDialog">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="warning" @click="onConfirm">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis.js';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],
  components: {},
  data() {
    return {
      inputVisible: false,
      inputValue: '',
      form: {
        // 目标面积
        goalArea: '',
        // 目标时长（分钟）
        goalTime: '',
        siteId: '',
        siteName: '',
        locationId: '',
      },
    };
  },
  computed: {
    cleanAreaDay() {
      return this.$t('location_set_dialog.qjmjot', [this.$formatLenUnit()]);
    },
    rules() {
      return {
        goalArea: [
          {
            required: true,
            message: this.$t('Common.com_required'),
          },
        ],
        goalTime: [
          {
            required: true,
            message: this.$t('Common.com_required'),
          },
        ],
      };
    }
  },
  methods: {
    closeDialog() {
      this.visible = false;
    },
    onConfirm() {
      this.edit();
    },
    edit() {
      this.$refs.form.validate((val) => {
        if (val) {
          this.form.goalArea = this.$formatLenUpload(this.form.goalArea);
          if (this.model.type === 'setBatch') {
            this.form.siteIdList = this.model.data;
            this.$postJSON(apis.locationSiteSetGoalSelfBatch, this.form, true).then(() => {
              this.closeDialog();
              this.$message({
                type: 'success',
                message: this.$t('Common.com_edit_success'),
              });
              this.$emit('success');
            });
            return;
          }
          this.$postJSON(apis.locationSiteSetGoalSelf, this.form, true).then(() => {
            this.closeDialog();
            this.$message({
              type: 'success',
              message: this.$t('Common.com_edit_success'),
            });
            this.$emit('success');
          });
        }
      });
    },

    // getProjectInfo() {
    //   this.$getJSON(apis.locationInfo, { locationId: this.model.id }).then((res) => {
    //     const data = res.data || {};
    //     // console.log(this.model.data);
    //     this.$setFormatData(this.form, data);
    //     // 地址
    //     this.form.address = [];
    //     if (data.countryCode) {
    //       this.form.address.push(data.countryCode);
    //     }
    //     if (data.provinceCode) {
    //       this.form.address.push(data.provinceCode);
    //     }
    //     if (data.cityCode) {
    //       this.form.address.push(data.cityCode);
    //     }
    //   });
    // },
    initForm() {
      // setBatch 区域批量设置
      if (this.model.type === 'add' || this.model.type === 'setBatch') {
        return;
      }
      this.$setFormatData(this.form, this.model.data, 'siteId,siteName,locationId');
      // this.form.goalArea = this.$formatLenLocal(this.form.goalArea);
      // this.getProjectInfo();
    },
  },
  mounted() {
    this.initForm();
    // this.getLanguage();
  },
};
</script>

<style lang="scss">
@import 'style/colors.scss';
.location-item-dialog {
  .el-tag--small {
    height: 32px;
    line-height: 30px;
    margin-bottom: 10px;
  }
  .el-tag + .el-tag {
    margin-left: 10px;
  }
  .el-tag + .button-new-tag {
    margin-left: 10px;
  }
  .el-tag + .input-new-tag {
    margin-left: 10px;
  }
  .button-new-tag {
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-tag {
    width: 90px;
  }
  .detail-address {
    margin-top: 10px;
  }
  .title-box {
    padding: 0 24px 10px;
    border-bottom: 1px solid $--color-info;
    .location {
      font-weight: bold;
      font-size: 14px;
      line-height: 140%;
      color: $--color-text-primary;
    }
    .goal {
      font-size: 12px;
      line-height: 140%;
      color: $--color-text-secondary;
      span{
        padding-right:5px;
      }
      span + span{
        padding-left: 5px;
        border-left: 1px solid $--color-info;
      }
    }
  }
}
</style>
